// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__35LX0","legacyBtn":"MutateMid_legacyBtn__1QpcD"};